export default "__VITE_ASSET__mVLMvcQf__"